
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"_","data-name":"!","transform":"translate(-686.77 -382.398)"}},[_c('circle',{attrs:{"id":"Ellipse_302","data-name":"Ellipse 302","cx":"7","cy":"7","r":"7","transform":"translate(686.77 382.398)","fill":"#fbebdd"}}),_c('circle',{attrs:{"id":"Ellipse_303","data-name":"Ellipse 303","cx":"6.4","cy":"6.4","r":"6.4","transform":"translate(687.37 382.998)","fill":"none","stroke":"#f79836","stroke-width":"1.2"}}),_c('g',{attrs:{"id":"Line_459","data-name":"Line 459"}},[_c('path',{attrs:{"id":"Path_19471","data-name":"Path 19471","d":"M693.77 391.216a.75.75 0 01-.75-.75V386.2a.75.75 0 011.5 0v4.269a.75.75 0 01-.75.747z","fill":"#f79836"}})]),_c('g',{attrs:{"id":"Line_460","data-name":"Line 460"}},[_c('path',{attrs:{"id":"Path_19472","data-name":"Path 19472","d":"M693.77 393.35a.75.75 0 01-.529-1.281.619.619 0 01.239-.159.749.749 0 11.29 1.44z","fill":"#f79836"}})])])])
          )
        }
      }
    